(function (angular) {
    'use strict';

    angular.module('app')
        .service('queryParams', queryParams);

    // queryParams.$inject = [
    // ];

    /**
     * Gets any query parameters from the url and maps them to an object. (Taken from stackoverflow)
     * @return {object}
     */
    function queryParams() {
        var query_string = {},
            query = window.location.search.substring(1),
            vars = query.split("&"),
            i = 0,
            pair,
            arr;

        for (i = 0; i < vars.length; i++) {
            pair = vars[i].split("=");

            // If first entry with this name
            if (typeof query_string[pair[0]] === "undefined") {
                query_string[pair[0]] = decodeURIComponent(pair[1]);
                // If second entry with this name
            } else if (typeof query_string[pair[0]] === "string") {
                arr = [query_string[pair[0]], decodeURIComponent(pair[1])];
                query_string[pair[0]] = arr;
                // If third or later entry with this name
            } else {
                query_string[pair[0]].push(decodeURIComponent(pair[1]));
            }
        }

        return query_string;
    }

}(angular));
